export const PRIMARY_COLOR_STORAGE_KEY = 'platform-primary-color'
export const COLOR_SCHEME_STORAGE_KEY = 'platform-color-scheme'
